import { ChangeDetectionStrategy, Component, Input, WritableSignal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { User } from '@app/core/interfaces/user.interface';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  standalone: true,
  selector: 'ups-footer',
  templateUrl: './footer.component.html',
  styleUrls: [ './footer.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-block w-100 mt-lg-5' 
  },
  imports: [
    IonicModule,
    RouterModule,
    NgTemplateOutlet,
    TranslocoDirective
  ],
})
export class FooterComponent {

  @Input() public mode: 'desktop' | 'mobile' = 'desktop';
  public readonly year: number = (new Date()).getFullYear();
  public readonly user: WritableSignal<User> = this.authService.user;
  public readonly socmedMenu: { label: string, route: string }[] = [
    { label: 'Facebook', route: 'https://www.facebook.com/upstation.id/' },
    { label: 'Twitter', route: 'https://twitter.com/upstationmedia' },
    { label: 'Youtube', route: 'https://www.youtube.com/channel/UC5QYG1bL3Hw6jOrS7H7Kqog' },
    { label: 'LinkedIn', route: 'https://www.linkedin.com/company/pt-24-jam-online' }
  ];
  public readonly sitemapMenu: { label: string, route: string, icon?: string }[] = [
    { label: 'Article', route: '', icon: 'newspaper-outline' },
    { label: 'Watch', route: 'watch', icon: 'tv-outline' },
    { label: 'Deals', route: 'deals', icon: 'cart-outline' },
    { label: 'About Us', route: 'about-us' },
    { label: 'Write for Us', route: 'write-for-us' },
    { label: 'Cyber Media Guidelines', route: 'cyber-media-guidelines' },
    { label: 'Copyright & Disclaimer', route: 'copyright-disclaimer' }
  ];

  constructor(
    protected readonly authService: AuthService
  ) {}
}
